import { CircularProgress, Typography } from "@mui/material";
import commonStyles from "styles/common";

export default function CircularProgressWithLabel(props: {
    type?: string;
    value?: number;
    color?: any;
    style?: any;
    message?: string;
    width?: any;
    className?: any;
}) {
    const { classes: common } = commonStyles();
    var { type, value, color, style, width, message, className = '' } = props;
    if (type === "determinate" && value) {
        if (isNaN(value)) {
            value = 0;
        }
        if (value > 100) {
            value = 100;
        }
    }
    if (!color) {
        color = "secondary";
    }

    if (!width) {
        width = "100%";
    }
    return (
        <div
            className={`${common.middleCenter} ${className}`}
            style={{
                flexDirection: "column",
                width: width,
            }}
        >
            <div
                className={common.middleCenter}
                style={{
                    position: "relative",
                    flexDirection: "column",
                }}
            >
                <CircularProgress variant={value ? "determinate" : "indeterminate"} value={value} style={style} />
                {value ? (
                    <div
                        style={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography variant="caption" component="div" color={color} style={{ fontSize: 8 }}>
                            {`${Math.round(value)}%`}
                        </Typography>
                    </div>
                ) : (
                    ""
                )}
            </div>
            {message ? (
                <div className={common.middleCenter} style={{ width: "100%", textAlign: "center", marginTop: 10 }}>
                    <Typography className={common.mediumLabel}>{message}</Typography>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
